import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
import { SectionLabel } from './ui/Reveal';
import { stats } from '../data/site';
import { usePrefersReducedMotion } from '../hooks/useMedia';
function Counter({
  value,
  suffix
}: {
  value: number;
  suffix: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-15% 0px'
  });
  const reduced = usePrefersReducedMotion();
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    if (reduced) {
      setDisplay(value);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const duration = 1500;
    const tick = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(value * eased));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, reduced, value]);
  return <span ref={ref} className="tabular-nums" data-id="element-548" data-mp="57knpj7zoars">
      {display}
      {suffix}
    </span>;
}
export function Stats() {
  return <section className="bg-surface py-20 sm:py-28" aria-label="Achievements" data-id="element-549" data-mp="e6xxye3xt3dk">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-550" data-mp="a4ulbm5j7sqp">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-551" data-mp="a5m4tyluu00m">
          <SectionLabel data-id="element-552" data-mp="3il5tekbkyu9c">By the numbers</SectionLabel>
          <p className="max-w-sm text-sm text-muted" data-id="element-553" data-mp="3dm32e3sfqokd">
            Brand audits, identity systems and campaign work delivered for businesses across
            industries — remotely, worldwide.
          </p>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-y-10 border-t border-line pt-10 sm:gap-x-6 lg:grid-cols-4" data-id="element-554" data-mp="3ml6lh7rlr3yv">
          {stats.map(stat => <div key={stat.label} className="lg:border-l lg:border-line lg:pl-6 lg:first:border-l-0 lg:first:pl-0" data-id="element-555" data-mp="2yualvogwn4h2">
              <dd className="font-display text-[13vw] font-extrabold leading-[0.82] tracking-tightest sm:text-[7vw] lg:text-[4.6vw]" data-id="element-556" data-mp="xufju10rekt0">
                <Counter value={stat.value} suffix={stat.suffix} data-id="element-557" data-mp="12sh0kfapq81b" />
              </dd>
              <dt className="label mt-3 text-muted" data-id="element-558" data-mp="17jz0d01022kp">{stat.label}</dt>
            </div>)}
        </dl>
      </div>
    </section>;
}